// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import "@fontsource/inter";
// import LandingPage from "./LandingPage";
// import {
//   FingerprintJSPro,
//   FpjsProvider,
// } from "@fingerprintjs/fingerprintjs-pro-react";
//Pratham
// const root = ReactDOM.createRoot(
//   document.getElementById("root") as HTMLElement
// );
// root.render(
//   <React.StrictMode>
//     <FpjsProvider
//       loadOptions={{
//         apiKey: "LAQ3MT1FHparLBFLpNdg",
//         endpoint: [
//           "https://metrics.app20.co",
//           FingerprintJSPro.defaultEndpoint,
//         ],
//         scriptUrlPattern: [
//           "https://metrics.app20.co/web/v<version>/<apiKey>/loader_v<loaderVersion>.js",
//           FingerprintJSPro.defaultScriptUrlPattern,
//         ],
//         // region: "ap",
//       }}
//     >
//       <LandingPage />
//     </FpjsProvider>
//   </React.StrictMode>
// );

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "@fontsource/inter";
import LandingPage from "./pages/public/LandingPage";
// import PaymentHistoryPage from "./pages/dashboard/PaymentHistoryPage";
/* import {
  FpjsProvider,
} from "@fingerprintjs/fingerprintjs-pro-react"; */
import { HelmetProvider, Helmet } from 'react-helmet-async';

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { store } from "./store/store";
import { queryClient } from "./lib/queryClient";

import OnboardPage from "./pages/public/OnboardPage";
import TaskSubmissionPage from "./pages/public/TaskSubmissionPage";
import TaskSubmissionPageFB from "./pages/public/TaskSubmissionPageFB";
// import FacebookRedirect from "./pages/public/FacebookRedirect";
import PaymentProcessingPage from "./pages/status/PaymentProcessingPage";
import PaymentProcessingPageFb from "./pages/status/PaymentProcessingPageFb";
import PaymentSuccessPage from "./pages/status/PaymentSuccessPage";
/* import LoginPage from "./pages/auth/LoginPage";
import OtpPage from "./pages/auth/OtpPage";
import OffersFeedPage from "./pages/dashboard/OffersFeedPage";
import InstallOfferPage from "./pages/dashboard/InstallOfferPage";
import ProfilePage from "./pages/dashboard/ProfilePage"; */
import QRGenerator from "./components/QRGenerator";
import GTMTracker from "./components/GTMTracker";
import DesktopBlocker from "./components/common/DesktopBlocker";
// import ProtectedRoute from "./components/auth/ProtectedRoute";

import IntercomManager from "./components/common/IntercomManager";
import VersionChecker from "./components/common/VersionChecker";
import ErrorBoundary from "./components/common/ErrorBoundary";
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(r => r.unregister());
  });
}
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ErrorBoundary>
        <IntercomManager />
        <HelmetProvider>
          <QueryClientProvider client={queryClient}>
            {/* <FpjsProvider
              loadOptions={{
                apiKey: "LAQ3MT1FHparLBFLpNdg",
              }}
            > */}
            <BrowserRouter>
              <VersionChecker />
              <GTMTracker />
              <Helmet>
                <meta name="robots" content="noindex, nofollow" />
              </Helmet>
              <DesktopBlocker />
              <Routes>
                <Route path="/submit-task" element={<TaskSubmissionPage />} />
                <Route path="/submit-task-fb" element={<TaskSubmissionPageFB />} />
                <Route path="/payment-processing" element={<PaymentProcessingPage />} />
                <Route path="/payment-processing-fb" element={<PaymentProcessingPageFb />} />
                <Route path="/payment-success" element={<PaymentSuccessPage />} />
                {/* <Route path="/login" element={<LoginPage />} />
                  <Route path="/otp-verify" element={<OtpPage />} /> */}

                {/* Protected Routes */}
                {/* <Route element={<ProtectedRoute />}>
                    <Route path="/dashboard" element={<OffersFeedPage />} />
                    <Route path="/offer-install/*" element={<InstallOfferPage />} />
                    <Route path="/profile" element={<ProfilePage />} />
                    <Route path="/payment-history" element={<PaymentHistoryPage />} />
                  </Route> */}

                <Route path="/onboard" element={<OnboardPage />} />
                <Route path="/qr-generator" element={<QRGenerator />} />
                <Route path="/fb" element={<LandingPage />} />
                {/* Catch-all route must be last */}
                <Route path="/*" element={<LandingPage />} />
              </Routes>
            </BrowserRouter>
            {/* </FpjsProvider> */}
            {/* React Query Devtools - only in development */}
            {process.env.NODE_ENV === "development" && (
              <ReactQueryDevtools initialIsOpen={false} />
            )}
          </QueryClientProvider>
        </HelmetProvider>
      </ErrorBoundary>
    </Provider>
  </React.StrictMode>
);
